import { Component, computed, inject } from "@angular/core";
import { ConnectionLostBarService } from "./services/ConnectionLostBarService";
import { LanguageServices } from "./services/LanguageServices";

@Component({
    selector: 'connection-lost-bar',
    standalone: true,
    template: `
        <div class="connection-bar" [class.visible]="bar.offline()" role="alert" aria-live="assertive">
            <span class="dot"></span>
            <span>{{ message() }}</span>
        </div>
        `,
    styles: [`
        .connection-bar {
            position: relative;
            width: 100%;
            display: flex;
            align-items: center;
            justify-content: center;
            gap: 10px;
            background: #b3261e;
            color: #fff;
            font: 500 14px/1.2 system-ui, -apple-system, sans-serif;
            overflow: hidden;
            transform: translateY(-100%);
            opacity: 0;
            max-height: 0;
            padding: 0 16px;
            transition: transform .35s ease, max-height .35s ease, opacity .25s ease, padding .35s ease;
        }
        .connection-bar.visible {
            transform: translateY(0);
            opacity: 1;
            max-height: 80px;
            padding: 10px 16px;
        }
        .dot {
            width: 8px;
            height: 8px;
            border-radius: 50%;
            background: #fff;
            animation: cb-pulse 1s ease-in-out infinite;
        }
        @keyframes cb-pulse {
            0%, 100% { opacity: .4; }
            50%      { opacity: 1; }
        }
    `],
})
export class ConnectionBarComponent {
    bar = inject(ConnectionLostBarService);
    ls = inject(LanguageServices)

     message = computed(() => {
        switch (this.bar.reason()) {
            case 'local':
                return this.ls.instant('app.connection-lost.local');
            case 'server':
                return this.ls.instant('app.connection-lost.server');
            default:
                return this.ls.instant('app.connection-lost');
        }
    });
}